export default __webpack_public_path__ + "static/media/profile2.f5d903c7.png";